import { MultiplierAnimationConfig } from '@Animation/types'
import { preLoadAssets } from './asset-preloader'
import { CyberSnakesMultiplierAnimation } from './cyber-snakes-multiplier-animation'

export const CYBER_SNAKES_MULTIPLIER_CONFIG: MultiplierAnimationConfig = {
  assetPreloader: preLoadAssets,
  revealAnimation: CyberSnakesMultiplierAnimation,
}
